"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
exports.getPermissions = (data, type) => R.pipe(R.pathOr([], [type]), R.pipe(R.pathOr([], ['permissions', 'items']), R.groupBy(R.prop('resourceType')), R.mapObjIndexed(R.indexBy(R.prop('resource')))))(data);
//# sourceMappingURL=getPermissions.js.map